import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        component: resolve => require(['../views/Home.vue'], resolve)
    },
    {
        path: '/patent',
        component: resolve => require(['../views/Patent.vue'], resolve)
    },
    {
        path: '/company',
        component: resolve => require(['../views/Company.vue'], resolve)
    },
    {
        path: '/about',
        component: resolve => require(['../views/About.vue'], resolve)
    },
    {
        path: '/product1',
        component: resolve => require(['../views/Product1.vue'], resolve)
    },
    {
        path: '/product2',
        component: resolve => require(['../views/Product2.vue'], resolve),
        // children: [
        //     {
        //         path: '*',
        //         component: resolve => require(['../views/404.vue'], resolve),
        //     }
        // ]
    },
    {
        path: '/page1',
        component: resolve => require(['../views/page/Page1.vue'], resolve)
    }, {
        path: '/page2',
        component: resolve => require(['../views/page/Page2.vue'], resolve)
    },
];

export default new Router({
    mode: 'hash',
    routes,
})




// WEBPACK FOOTER //
// ./src/router/index.js